
				var addMethods = require("../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["connectWS","sendEvent","closeWS","test"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "b1c507ae2549895e21c1.worker.js", { name: "[fullhash].worker.js" })
					URL.revokeObjectURL(__webpack_public_path__ + "b1c507ae2549895e21c1.worker.js");
					addMethods(w, methods)
					
					return w
				}
			